import PlaceDetails from "./PlaceDetails";

export default PlaceDetails;